import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslate, DashboardMenuItem, MenuItemLink, Responsive } from 'react-admin';
import users from 'cw-core-admin-ui/src/resources/users';
import wallets from 'cw-core-admin-ui/src/resources/wallets';
import payments from 'cw-core-admin-ui/src/resources/payments';
import accountingAccounts from 'cw-core-admin-ui/src/resources/accountingAccounts';
import marketplaces from '../resources/marketplaces';
import SubMenu from 'cw-core-admin-ui/src/layout/SubMenu';

const Menu = ({ onMenuClick, logout }) => {
	const [menuUsers, setMenuUsers] = useState(false);
	const [menuWallets, setMenuWallets] = useState(false);
	const [menuTransactions, setMenuTransactions] = useState(false);
	const [menuConfig, setMenuConfig] = useState(false);
	const [menuPaymentAdministration, setMenuPaymentAdministration] = useState(false);
	const [menuAccounting, setMenuAccounting] = useState(false);
	const [menuMarketplace, setMenuMarketplace] = useState(false);
	const translate = useTranslate();
	const open = useSelector((state) => state.admin.ui.sidebarOpen);

	return (
		<>
			<DashboardMenuItem onClick={onMenuClick} />
			<SubMenu handleToggle={() => setMenuUsers(!menuUsers)} isOpen={menuUsers} sidebarIsOpen={open} name="coreWalletAdmin.menu.users" icon={<users.icon />}>
				<MenuItemLink
					to={`/users`}
					primaryText={translate(`resources.users.name`, {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
			</SubMenu>
			<SubMenu handleToggle={() => setMenuWallets(!menuWallets)} isOpen={menuWallets} sidebarIsOpen={open} name="coreWalletAdmin.menu.wallets" icon={<wallets.icon />}>
				<MenuItemLink
					to={'/subsidiaries'}
					primaryText={translate('resources.subsidiaries.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<MenuItemLink
					to={`/wallets`}
					primaryText={translate(`resources.wallets.name`, {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<MenuItemLink
					to={`/walletAccounts`}
					primaryText={translate(`resources.walletAccounts.name`, {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<MenuItemLink
					to={`/paymentInstruments`}
					primaryText={translate(`resources.paymentInstruments.name`, {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<MenuItemLink
					to={'/walletNotifications'}
					primaryText={translate('resources.walletNotifications.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<SubMenu sidebarIsOpen={open} name="coreWalletAdmin.menu.transactions" handleToggle={() => setMenuTransactions(!menuTransactions)} isOpen={menuTransactions} icon={null}>
					<MenuItemLink
						to={'/balanceTransactions'}
						primaryText={translate('resources.balanceTransactions.name', {
							smart_count: 3,
						})}
						onClick={onMenuClick}
					/>
					<MenuItemLink
						to={'/payments'}
						primaryText={translate('resources.payments.name', {
							smart_count: 3,
						})}
						onClick={onMenuClick}
					/>
					<MenuItemLink
						to={'/invoices'}
						primaryText={translate('resources.invoices.name', {
							smart_count: 3,
						})}
						onClick={onMenuClick}
					/>
					<MenuItemLink
						to={'/purchases'}
						primaryText={translate('resources.purchases.name', {
							smart_count: 3,
						})}
						onClick={onMenuClick}
					/>
				</SubMenu>
				<SubMenu handleToggle={() => setMenuConfig(!menuConfig)} isOpen={menuConfig} sidebarIsOpen={open} name="coreWalletAdmin.menu.config" icon={null}>
					<MenuItemLink
						to={'/currencies'}
						primaryText={translate('resources.currencies.name', {
							smart_count: 2,
						})}
						onClick={onMenuClick}
					/>
					<MenuItemLink
						to={'/feeGroups'}
						primaryText={translate('resources.feeGroups.name', {
							smart_count: 2,
						})}
						onClick={onMenuClick}
					/>
					<MenuItemLink
						to={'/feeDefinitions'}
						primaryText={translate('resources.feeDefinitions.name', {
							smart_count: 2,
						})}
						onClick={onMenuClick}
					/>
					<MenuItemLink
						to={'/limitGroups'}
						primaryText={translate('resources.limitGroups.name', {
							smart_count: 2,
						})}
						onClick={onMenuClick}
					/>
					<MenuItemLink
						to={'/limitDefinitions'}
						primaryText={translate('resources.limitDefinitions.name', {
							smart_count: 2,
						})}
						onClick={onMenuClick}
					/>
					<MenuItemLink
						to={'/vatDefinitions'}
						primaryText={translate('resources.vatDefinitions.name', {
							smart_count: 2,
						})}
						onClick={onMenuClick}
					/>
					<MenuItemLink
						to={'/blackWhiteLists'}
						primaryText={translate('resources.blackWhiteLists.name', {
							smart_count: 2,
						})}
						onClick={onMenuClick}
					/>
					<MenuItemLink
						to={'/shopConfigurations'}
						primaryText={translate('resources.shopConfigurations.name', {
							smart_count: 2,
						})}
						onClick={onMenuClick}
					/>
				</SubMenu>
				<MenuItemLink
					to={`/loyaltyPrograms`}
					primaryText={translate('resources.loyaltyPrograms.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
			</SubMenu>
			<SubMenu handleToggle={() => setMenuAccounting(!menuAccounting)} isOpen={menuAccounting} sidebarIsOpen={open} name="coreWalletAdmin.menu.accounting" icon={<accountingAccounts.icon />}>
				<MenuItemLink
					to={'/accountingAccounts'}
					primaryText={translate('resources.accountingAccounts.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<MenuItemLink
					to={'/accountingAccountItems'}
					primaryText={translate('resources.accountingAccountItems.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<MenuItemLink
					to={'/accountingAccountTransfers'}
					primaryText={translate('resources.accountingAccountTransfers.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
			</SubMenu>
			<SubMenu handleToggle={() => setMenuPaymentAdministration(!menuPaymentAdministration)} isOpen={menuPaymentAdministration} sidebarIsOpen={open} name="coreWalletAdmin.menu.payment" icon={<payments.icon />}>
				<MenuItemLink
					to={'/paymentTransactions'}
					primaryText={translate('resources.paymentTransactions.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<MenuItemLink
					to={'/paymentFailures'}
					primaryText={translate('resources.paymentFailures.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<MenuItemLink
					to={'/paymentApprovals'}
					primaryText={translate('resources.paymentApprovals.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<MenuItemLink
					to={'/unmatchedPayments'}
					primaryText={translate('resources.unmatchedPayments.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<MenuItemLink
					to="/invoiceVouchers"
					primaryText={translate('resources.invoiceVouchers.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<MenuItemLink
					to={'/businessContracts'}
					primaryText={translate('resources.businessContracts.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<MenuItemLink
					to={'/binGroups'}
					primaryText={translate('resources.binGroups.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
			</SubMenu>
			<Responsive
				small={logout}
				medium={null} // Pass null to render nothing on larger devices
			/>
			<SubMenu handleToggle={() => setMenuMarketplace(!menuMarketplace)} isOpen={menuMarketplace} sidebarIsOpen={open} name="resources.menu.marketplaces" icon={<marketplaces.icon />}>
				<MenuItemLink
					to={'/marketplaces'}
					primaryText={translate('resources.marketplaces.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<MenuItemLink
					to={'/marketplaceSellers'}
					primaryText={translate('resources.marketplaceSellers.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
				<MenuItemLink
					to={'/marketplacePurchases'}
					primaryText={translate('resources.marketplacePurchases.name', {
						smart_count: 2,
					})}
					onClick={onMenuClick}
				/>
			</SubMenu>
			<Responsive
				small={logout}
				medium={null} // Pass null to render nothing on larger devices
			/>
		</>
	);
};

Menu.propTypes = {
	onMenuClick: PropTypes.func,
	logout: PropTypes.object,
};

export default Menu;
